<header class="navbar navbar-fixed-top bg-system">
    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/" ng-click="mainPage()">
                <img src="img/logo-blue.svg" alt="Hodxpress.com">
            </a>
        </li>
    </ul>

    <ul class="nav navbar-nav navbar-right">
        <li ng-class="{ active: isActive('order-report')}">
            <a href="order-report">Order Report</a>
        </li>
        <li ng-class="{ active: isActive('partner-report')}">
            <a href="partner-report">Partner Report</a>
        </li>
        <li ng-class="{ active: isActive('invoice-reports')}">
            <a href="invoice-reports">Invoice Report</a>
        </li>
        <!-- <li ng-class="{ active: isActive('gelir-gider')}">
            <a href="gelir-gider">Gelir Gider Raporları</a>
        </li> -->
        <!-- <li ng-class="{ active: isActive('iade-teslim')}">
            <a href="iade-teslim">İade Teslim Formu</a>
        </li> -->
        <!-- <li ng-class="{ active: isActive('form-raporlari')}">
            <a href="form-raporlari">Form Raporları</a>
        </li> -->
        <li ng-class="{ active: isActive('driver-reports')}">
            <a href="driver-reports">Driver Report</a>
        </li>
        <li ng-class="{ active: isActive('earning-reports')}">
            <a href="earning-reports">Earning Report</a>
        </li>
    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" >
        
    <ul class="nav navbar-nav navbar-left hidden-xs" ng-if="isActive(['order-report', 'invoice-reports', 'earning-reports', 'partner-report'])">
        <div class="form-group floating">
            <input 
                type="text" 
                options="opts" 
                date-range-picker 
                ng-model="filterData.created_at"
                class="btn btn-operation ml10" 
                placeholder="By Date">
        </div>

        <a href="#" 
            class="btn w50 p-2 ml10" 
            ng-click="refreshData('invoice-reports')" 
            style="line-height: 20px;"
            ng-show="filterData.created_at.startDate">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" 
            class="clear-filter ml-3" 
            ng-show="filterData.created_at.startDate"
            ng-click="clearFilter()" 
            style="line-height: 20px;">
            Clear Filter
        </a>
    </ul>

    <ul class="nav navbar-nav navbar-left hidden-xs" ng-if="isActive(['gelir-gider'])">
            
        <!-- <input 
            type="text" 
            ng-model="filterData.term" 
            class="btn btn-operation ml10 text-input" 
            placeholder="Kargo No" >
     -->
        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.scheduled_time" 
            class="btn btn-operation ml10" 
            placeholder="Kargo Tarihi" >

        
        <!-- <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select> -->

        <ui-select 
            ng-model="filterData.customer_id" 
            title="Müşteri" 
            class="ml10 operation-live-search" 
            style="width:200px" 
            duplicates-allowed="false"
            >
            <ui-select-match placeholder="Müşteri Seçiniz...">
                {{ $select.selected.customer_name }}
            </ui-select-match>
            <ui-select-choices repeat="item.id as item in (data.customers | filter: $select.search ) track by $index">
                <span ng-bind-html="item.customer_name | highlight: $select.search"></span>
            </ui-select-choices>
        </ui-select>
        
        <select class="ml10 selectpicker" 
            multiple 
            title="Kargo Durumu"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workSteps"
            data-style="btn-primary">
            <option ng-repeat="item in data.workSteps" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
        </select>

        <select class="ml10 selectpicker" 
            multiple 
            title="Kargo Türü"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workTypes"
            data-style="btn-primary">
            <option ng-repeat="item in data.workTypes" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
        </select>

        <a href="#" class="btn btn-warning ml10" ng-click="refreshData('order_list')" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
            <i class="fa fa-times"></i>
        </a>

    </ul>

    <ul class="nav navbar-nav navbar-left hidden-xs" ng-if="isActive(['form-raporlari'])">
    
        <select class="ml10 selectpicker" 
            title="Form"
            data-language="tr_TR"
            ng-model="filterData.form_id"
            data-style="btn-primary">
            <option ng-repeat="member in data.forms" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.name}}</option>
        </select>

        <ui-select ng-model="filterData.customers" title="Müşteri" class="ml10 operation-live-search" style="width:200px" multiple>
            <ui-select-match placeholder="Müşteri Seçiniz...">{{ $item.customer_name }}</ui-select-match>
            <ui-select-choices refresh="searchCustomer($select,'')" refresh-delay="0" repeat="searchRes in searchRes">
                <span ng-bind-html="searchRes.customer_name | highlight: $select.search"></span>
            </ui-select-choices>
        </ui-select>

        <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select>

        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.created_at" 
            class="btn btn-operation ml10" 
            placeholder="Oluşturma Tarihi" >

    
        <a href="#" class="btn btn-operation ml10" ng-click="refreshData('form_reports')" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>
        
    </ul>

    <ul class="nav navbar-nav navbar-left hidden-xs" ng-if="isActive(['driver-reports'])">
        
        <div class="form-group floating">
            <input 
                type="text" 
                options="opts" 
                date-range-picker 
                ng-model="filterData.time"
                class="btn btn-operation ml10" 
                placeholder="By Date">
        </div>

        <a href="#" 
            class="btn w50 p-2 ml10" 
            ng-click="refreshData('worker_reports')" 
            style="line-height: 20px;"
            ng-show="filterData.time.startDate">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" 
            class="clear-filter ml-3" 
            ng-show="filterData.time.startDate"
            ng-click="filter('clear')" 
            style="line-height: 20px;">
            Clear Filter
        </a>
        
    </ul>

    <ul class="nav navbar-nav navbar-left hidden-xs" ng-if="isActive(['iade-teslim'])">
        
        <input 
            type="text" 
            ng-model="filterData.term" 
            class="btn btn-operation ml10 text-input" 
            placeholder="Kargo No" >
    
        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.scheduled_time" 
            class="btn btn-operation ml10" 
            placeholder="Kargo Tarihi" >

        <input 
            type="text" 
            ng-model="filterData.location" 
            class="btn btn-operation ml10 text-input" 
            placeholder="Teslimat Müşteri Adı">
        
        <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select>

        <ui-select 
            ng-model="filterData.customer_id" 
            title="Müşteri" 
            class="ml10 operation-live-search" 
            style="width:200px" 
            duplicates-allowed="false"
            >
            <ui-select-match placeholder="Müşteri Seçiniz...">
                {{ $select.selected.customer_name }}
            </ui-select-match>
            <ui-select-choices repeat="item.id as item in (data.customers | filter: $select.search ) track by $index">
                <span ng-bind-html="item.customer_name | highlight: $select.search"></span>
            </ui-select-choices>
        </ui-select>
        
        <select class="ml10 selectpicker" 
            multiple 
            title="Kargo Türü"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workTypes"
            data-style="btn-primary">
            <option ng-repeat="item in data.workTypes" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
        </select>

        <a href="#" class="btn btn-warning ml10" ng-click="refreshData('order_list')" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
            <i class="fa fa-times"></i>
        </a>

    </ul>

    <div class="nav navbar-nav navbar-center"></div>
    <ul class="nav navbar-nav navbar-right">
        
        <!-- <li ng-if="isActive(['iade-teslim'])">
            <a href="#" ng-click="exportReturn()" class="btn btn-warning btn-rounded">
                <i class="fa fa-excel"></i> İade Teslim Formu
            </a>
        </li>
        <li ng-if="!isActive(['iade-teslim']) && !isActive(['gelir-gider'])">
            <a href="#" ng-click="export()" class="btn btn-warning btn-rounded">
                Dışa Aktar
            </a>
        </li>
        <li ng-if="isActive(['gelir-gider'])" class="mr10">
            <a href="#" 
                data-toggle="modal" 
                data-target="#paymentOrdersModal" class="btn btn-warning">
                <i class="fa fa-money"></i> Ödeme Ekle
            </a>
        </li> -->
        <!-- <li ng-if="isActive(['gelir-gider'])">
            <a href="#" ng-click="exportCari()" class="btn btn-success">
                <i class="fa fa-file-excel-o"></i> Cari Extre
            </a>
        </li> -->

    </ul>
    
</header>
